<template>
  <WdsStack direction-column class="tw-gap-7">
    <MetricsNumbers :metrics="metrics" :loading="loading" />

    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-7">
      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <MyContracts
          :title="$t('Placements')"
          see-older-route="placements.index"
          :empty-state-text="$t('You don\'t have any active placements')"
          :empty-state-action="null"
          show-request-payment="managed-only"
        />
        <StaffingAgencyClients />
      </div>

      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <MyTasks />
        <SharedWithYou :account-types="recruiterAccountTypes" />
      </div>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { AccountType } from '@/gql/graphql'
import { useTranslation } from '@/composables/translation'
import { StaffingAgencyMetricsQuery } from '@/components/Dashboard/Metrics/staffing-agency-queries'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import laravelNamedRoutes from '@/utils/laravelNamedRoutes.json'
import MetricsNumbers from '@/components/Dashboard/Metrics/MetricsNumbers.vue'
import MyContracts from '@/components/Dashboard/Widgets/MyContracts.vue'
import MyTasks from '@/components/Dashboard/Widgets/MyTasks.vue'
import SharedWithYou from '@/components/Dashboard/Widgets/SharedWithYou.vue'
import StaffingAgencyClients from '@/components/Dashboard/Widgets/Clients/StaffingAgencyClients.vue'

const { $t } = useTranslation()

const account = computed(() => currentAccount.globalId)

const { result, loading } = useQuery(
  StaffingAgencyMetricsQuery,
  () => ({
    accounts: [account.value],
  }),
  {
    clientId: 'publicApi',
  },
)

const metrics = computed(() => [
  {
    label: $t('Shared jobs'),
    value: result.value?.sharedJobs.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(
      laravelNamedRoutes.frontend.jobs['shared-with-recruiter'],
    ),
  },
  {
    label: $t('Active placements'),
    value: result.value?.activePlacements.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.placements.index),
  },
  {
    label: $t('Pending bills'),
    value: result.value?.pendingBills.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.placements.bills),
  },
  {
    label: $t('Candidates'),
    value: result.value?.candidates.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(
      laravelNamedRoutes['recruiter-candidates'].index,
    ),
  },
  {
    label: $t('Pending actions'),
    value: result.value?.candidatesNeedingAction.paginatorInfo.total ?? 0,
    url: `${laravelNamedRoute(laravelNamedRoutes['recruiter-candidates'].index)}?action=needed`,
  },
])

const recruiterAccountTypes = [AccountType.Recruiter]
</script>
